import { motion } from 'motion/react'
import styled, { keyframes } from 'styled-components'

export const Header = styled.div`
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  background-color: ${props => props.theme.colors.background.primary};
  padding-bottom: ${props => props.theme.spacing.sp8};
`

export const ProgressSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const ProgressBarRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp16};
  width: 100%;
`

export const ProgressBar = styled.div`
  flex: 1;
  background-color: ${props => props.theme.colors.border.subtle};
  border-radius: ${props => props.theme.primitives.radius.radiusFull};
  height: ${props => props.theme.size['3XS']};
  min-width: 0;
  overflow: hidden;
`

const shimmer = keyframes`
  0% {
    background-position: 0% 0;
  }
  100% {
    background-position: 200% 0;
  }
`

export const ProgressBarContent = styled(motion.div)`
  height: ${props => props.theme.size['3XS']};
  background: linear-gradient(
    to right,
    ${props => props.theme.palette.pink.tone700},
    ${props => props.theme.palette.pink.tone400},
    ${props => props.theme.palette.pink.tone200},
    ${props => props.theme.palette.pink.tone400},
    ${props => props.theme.palette.pink.tone700}
  );
  border-radius: ${props => props.theme.primitives.radius.radiusFull};
  background-size: 200% 100%;
  animation: ${shimmer} 2s ease-in-out infinite;
`

export const StopButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-weight: 700;
  font-size: 14px;
  line-height: ${props => props.theme.size.XXS};
  color: ${props => props.theme.colors.outline.default};
  padding: ${props => props.theme.spacing.sp4} ${props => props.theme.spacing.sp8};
  white-space: nowrap;
  flex-shrink: 0;
`
